module.exports = __webpack_public_path__ + "img/money_icons.d369a6ea.png";